module.exports = __webpack_public_path__ + "qr.png";